import authController from './authController'

export default authController



// WEBPACK FOOTER //
// ../src/controllers/authController/index.js